import React from 'react';
import { motion } from 'framer-motion';
import { Camera } from 'lucide-react';
export function FleetShowcase() {
  const fleet = [{
    image: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&q=80',
    division: 'Roofing Division'
  }, {
    image: 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=600&q=80',
    division: 'Siding & Gutters Division'
  }, {
    image: 'https://images.unsplash.com/photo-1586864387789-628af9feed72?w=600&q=80',
    division: 'Commercial Division'
  }];
  return <section className="py-20 bg-white border-t border-gray-100" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-122">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-123">
            Our Fleet — Look for Us in Your Neighborhood
          </h2>
          <div className="w-20 h-1 bg-brand-blue mx-auto mb-6 rounded-full" data-id="element-124"></div>
          <p className="font-body text-brand-gray text-lg" data-id="element-125">
            Our branded vehicles are a familiar sight across Macomb and St.
            Clair counties. When you see our trucks, you know quality work is
            happening nearby.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" data-id="element-126">
          {fleet.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="group" data-id="element-127">
              <div className="relative rounded-xl overflow-hidden shadow-lg mb-4 aspect-[4/3]" data-id="element-128">
                <div className="brand-overlay h-full" data-id="element-129">
                  <img src={item.image} alt={`Moceri ${item.division} Van`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-130" />
                </div>
                {/* Decorative accent */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-brand-blue transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 z-10" data-id="element-131"></div>
              </div>
              <h3 className="font-heading font-bold text-xl text-brand-gray-dark text-center group-hover:text-brand-blue transition-colors" data-id="element-132">
                {item.division}
              </h3>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-3 text-brand-gray bg-gray-50 py-4 px-6 rounded-lg max-w-md mx-auto border border-gray-100" data-id="element-133">
          <Camera size={20} className="text-brand-blue" data-id="element-134" />
          <p className="font-body text-sm font-medium" data-id="element-135">
            Spot our trucks? Snap a photo and tag us on social media!
          </p>
        </motion.div>
      </div>
    </section>;
}